export const REQUEST_PRODUCT_TYPE = 'product/REQUEST_PRODUCT_TYPE';
export const RECEIVE_PRODUCT_TYPE = 'product/RECEIVE_PRODUCT_TYPE';
export const ERROR_RECEIVED = 'product/ERROR_RECEIVED';
export const REQUEST_GET_ALL_PRODUCT =  'product/REQUEST_GET_ALL_PRODUCT';
export const REQUEST_RECEIVED_ALL_PRODUCT = 'product/REQUEST_RECEIVED_ALL_PRODUCT';
export const REQUEST_EMPTY_ALL_PRODUCT = 'product/REQUEST_EMPTY_ALL_PRODUCT';
export const REQUEST_RECEIVED_ALL_ACTIVE_PRODUCT = 'product/REQUEST_RECEIVED_ALL_ACTIVE_PRODUCT';
export const REQUEST_GET_PRODUCT_BY_ID = 'product/REQUEST_GET_PRODUCT_BY_ID';
export const RECEIVE_GET_PRODUCT_BY_ID = 'product/RECEIVE_GET_PRODUCT_BY_ID';